






import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {},
  computed: {
    attrs(): any {
      return {
        loading: this.inProgress,
        depressed: true,
        color: 'primary',
        ...this.$attrs,
      };
    },
    listeners(): any {
      return {
        ...this.$listeners,
        click: this.handleClick,
      };
    },
  },
  data(): {
    inProgress: boolean;
  } {
    return {
      inProgress: false,
    };
  },
  methods: {
    async handleClick(...params: any[]) {
      if (this.$listeners.click) {
        this.inProgress = true;
        try {
          const result = await (this.$listeners.click as any)(...params);
        } finally {
          this.inProgress = false;
        }
      }
    },
  },
});
